/**
 * API Configuration
 *
 * Centralizes API URL configuration for all environments.
 *
 * Development: Uses empty string (relative URLs) which works with the Vite proxy in vite.config.js
 * Production: Uses VITE_API_URL environment variable set in Railway
 *
 * Usage:
 *   import { apiUrl } from '../config/api';
 *   fetch(apiUrl('/api/auth/login'), ...)
 */

export const API_BASE_URL = import.meta.env.VITE_API_URL || '';

/**
 * Helper function to build full API URLs
 * @param {string} path - API path (e.g., '/api/auth/login')
 * @returns {string} - Full URL or relative path depending on environment
 */
export const apiUrl = (path) => {
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};

/**
 * Helper for fetch calls with common configuration
 * @param {string} path - API path
 * @param {object} options - Fetch options
 * @returns {Promise<Response>}
 */
export const apiFetch = (path, options = {}) => {
  return fetch(apiUrl(path), {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};
